import { Grid, Typography } from '@mui/material'
import s from './DeliveryMatrixSummary.modules.scss'
import { Capsule } from 'components/core-ui/Capsule'

const DeliveryMatrixSummary = ({ item }) => {
  return (
    <Grid container flexDirection="column">
      <Grid item>
        <Typography className={s.hubName} fontWeight={700}>
          {item.destinationName}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default DeliveryMatrixSummary
